import type { Survey, SurveyListItem } from '@api/surveys/types';
import { pausableSurveyStatuses } from '@api/surveys';
import type { UserPermissions } from '@api/user/types';

export const canPauseSurvey = ({
  permissions,
  survey,
  useCalypsoProvider,
}: {
  permissions?: UserPermissions;
  survey?: Survey | SurveyListItem;
  useCalypsoProvider: boolean;
}) => {
  return Boolean(
    survey &&
    survey.atlasInstantSurveyRef &&
    !survey.isPaused &&
    pausableSurveyStatuses.includes(survey.status) &&
    useCalypsoProvider &&
    (survey.isOwner || permissions?.canAdvancedEditSurvey)
  );
};

export const canResumeSurvey = ({
  permissions,
  survey,
  useCalypsoProvider,
}: {
  permissions?: UserPermissions;
  survey?: Survey | SurveyListItem;
  useCalypsoProvider: boolean;
}) => {
  return Boolean(
    survey &&
    survey.atlasInstantSurveyRef &&
    survey.isPaused &&
    permissions?.canAdvancedEditSurvey &&
    useCalypsoProvider
  );
};
